import { Component } from '@angular/core';

@Component({
  selector: 'app-question',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_482_2781)">
    <path
      d="M11.314 0.260742C5.5273 0.260742 0.813965 4.97408 0.813965 10.7607C0.813965 16.5474 5.5273 21.2607 11.314 21.2607C17.1006 21.2607 21.814 16.5474 21.814 10.7607C21.814 4.97408 17.1006 0.260742 11.314 0.260742ZM11.314 19.5107C6.48396 19.5107 2.56396 15.5907 2.56396 10.7607C2.56396 5.93074 6.48396 2.01074 11.314 2.01074C16.144 2.01074 20.064 5.93074 20.064 10.7607C20.064 15.5907 16.144 19.5107 11.314 19.5107ZM13.9973 5.74408C14.709 6.45574 15.1056 7.41241 15.1056 8.42741C15.1056 9.44241 14.709 10.3874 13.9973 11.1107C13.4956 11.6124 12.8656 11.9624 12.189 12.1141V12.5107C12.189 12.9891 11.7923 13.3857 11.314 13.3857C10.8356 13.3857 10.439 12.9891 10.439 12.5107V11.3441C10.439 10.8657 10.8356 10.4691 11.314 10.4691C11.8623 10.4691 12.3756 10.2591 12.7606 9.87407C13.1456 9.48907 13.3556 8.97574 13.3556 8.42741C13.3556 7.87908 13.1456 7.36574 12.7606 6.98074C11.9906 6.21074 10.649 6.21074 9.87897 6.98074C9.49397 7.36574 9.28396 7.87908 9.28396 8.42741C9.28396 8.90574 8.8873 9.30241 8.40896 9.30241C7.93063 9.30241 7.53396 8.90574 7.53396 8.42741C7.53396 7.41241 7.93063 6.46741 8.6423 5.74408C10.0773 4.30908 12.574 4.30908 14.009 5.74408H13.9973ZM12.4806 15.7191C12.4806 16.3607 11.9556 16.8857 11.314 16.8857C10.6723 16.8857 10.1473 16.3607 10.1473 15.7191C10.1473 15.0774 10.6723 14.5524 11.314 14.5524C11.9556 14.5524 12.4806 15.0774 12.4806 15.7191Z"
      fill="#043B22"
    />
  </g>
  <defs>
    <clipPath id="clip0_482_2781">
      <rect
        width="21"
        height="21"
        fill="white"
        transform="translate(0.813965 0.260742)"
      />
    </clipPath>
  </defs>
</svg>
`
})
export class QuestionComponent {

}
